import { api } from 'src/boot/axios'
import { ActivitiesApi } from './activities'
import { AnnouncementsApi } from 'src/api/announcements'
import { AuthApi } from './auth'
import { DiaryApi } from './diary'
import { DocumentsApi } from 'src/api/documents'
import { ExercisesApi } from './exercises'
import { FavoritesApi } from './favorites'
import { MeasurementsApi } from './measurements'
import { NutritionApi } from './nutrition'
import { PaymentsApi } from './payments'
import { ProfileApi } from './profile'
import { WaterConsumptionApi } from './water'
import { WorkoutsApi } from './workouts'


export const activitiesApi = new ActivitiesApi(api)
export const announcementsApi = new AnnouncementsApi(api)
export const authApi = new AuthApi(api)
export const diaryApi = new DiaryApi(api)
export const documentsApi = new DocumentsApi(api)
export const exercisesApi = new ExercisesApi(api)
export const favoritesApi = new FavoritesApi(api)
export const measurementsApi = new MeasurementsApi(api)
export const nutritionApi = new NutritionApi(api)
export const paymentsApi = new PaymentsApi(api)
export const profileApi = new ProfileApi(api)
export const waterConsumptionApi = new WaterConsumptionApi(api)
export const workoutsApi = new WorkoutsApi(api)
